// const radioButtons = document.querySelectorAll('input[type="radio"]:not(.disabled)');
// let SizeApplied = 0;
// let maxLength = 0;
// const checkIntervalForSize = 1500;

// radioButtons.forEach(radioButton => {
//   const value = radioButton.value;
//   if (value.includes('cm')) {
//     const cmValue = parseInt(value.replace('cm', ''), 10);
//     if (cmValue > maxLength) {
//       maxLength = cmValue;
//     }
//   }
// });

// const url = window.location.href;
// const isFlatLinkChainSilver = url.includes('/products/flat-link-chain-anklet-silver');
// const isFlatLinkChainGold   = url.includes('/products/flat-link-chain-anklet-gold');

// let rangeInput = document.getElementById('engraveTxtRange');

// function checkSizeOrderSelected() {
//   const sizeOrderRadio = document.querySelector('input[value="サイズオーダー"]');
//   if (sizeOrderRadio && sizeOrderRadio.checked) {
//     if (rangeInput) {
//       let appliedMax = maxLength;

//       if (isFlatLinkChainSilver || isFlatLinkChainGold) {
//         appliedMax = maxLength + 4;
//       }
//       rangeInput.max = appliedMax;

//       let minValue = Math.max(appliedMax - 20, 10);
//       rangeInput.min = minValue;

//       if (SizeApplied === 0) {
//         document.getElementById('display02').textContent = minValue;
//         SizeApplied = 1;
//       }
//     }
//   } else {
//     if (rangeInput) {
//       document.getElementById('display02').textContent = "";
//       rangeInput.max = 0;
//       rangeInput.min = 0;
//       SizeApplied = 0;
//     }
//   }
// }

// setInterval(checkSizeOrderSelected, checkIntervalForSize);

document.addEventListener('DOMContentLoaded', function () {
  const radioButtons = document.querySelectorAll('input[type="radio"]:not(.disabled)');
  let SizeApplied = 0;
  let maxLength = 0;
  const checkIntervalForSize = 1500;

  const messageBox = document.querySelector('.option_message');
  const field = document.querySelector('.line-item-property__field');

  radioButtons.forEach(radioButton => {
    const value = radioButton.value;

    if (value.includes('cm')) {
      const cmValue = parseInt(value.replace('cm', ''), 10);

      if (cmValue > maxLength) {
        maxLength = cmValue;
      }
    }
  });

  const url = window.location.href;
  const isFlatLinkChainSilver = url.includes('/products/flat-link-chain-anklet-silver');
  const isFlatLinkChainGold = url.includes('/products/flat-link-chain-anklet-gold');

  const rangeInput = document.getElementById('engraveTxtRange');
  const display02 = document.getElementById('display02');

  function showSizeOrderArea() {
    if (messageBox) {
      messageBox.classList.add('is-visible');
    }

    if (field) {
      field.classList.add('is-visible');
    }
  }

  function hideSizeOrderArea() {
    if (messageBox) {
      messageBox.classList.remove('is-visible');
    }

    if (field) {
      field.classList.remove('is-visible');
    }
  }

  function checkSizeOrderSelected() {
    const sizeOrderRadio = document.querySelector('input[value="サイズオーダー"]');

    if (sizeOrderRadio && sizeOrderRadio.checked) {
      showSizeOrderArea();

      if (rangeInput) {
        let appliedMax = maxLength;

        if (isFlatLinkChainSilver || isFlatLinkChainGold) {
          appliedMax = maxLength + 4;
        }

        rangeInput.max = appliedMax;

        const minValue = Math.max(appliedMax - 20, 10);
        rangeInput.min = minValue;

        if (SizeApplied === 0) {
          if (display02) {
            display02.textContent = minValue;
          }

          rangeInput.value = minValue;
          SizeApplied = 1;
        }
      }
    } else {
      hideSizeOrderArea();

      if (rangeInput) {
        if (display02) {
          display02.textContent = "";
        }

        rangeInput.max = 0;
        rangeInput.min = 0;
        SizeApplied = 0;
      }
    }
  }

  radioButtons.forEach(radioButton => {
    radioButton.addEventListener('change', checkSizeOrderSelected);
  });

  checkSizeOrderSelected();

  setInterval(checkSizeOrderSelected, checkIntervalForSize);
});